import React from "react"
import FloatingActionButton from "material-ui/FloatingActionButton"
import ContentAdd from "material-ui/svg-icons/content/add"
import TableActionBar from "../../../components/layout/TableActionBar"
import { Paper, Table, TableBody, TableRow, TableRowColumn, CircularProgress, Toggle } from "material-ui"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { IScheduleShift } from "../../../models"
import AccountStore from "../../../stores/AccountStore"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import ShiftTemplatesTable from "./ShiftTemplatesTable"
import AddShiftTemplateDialog from "../../../components/schedule/add_shift_template/AddShiftTemplateDialog"
import * as AccountActions from "../../../actions/AccountActions"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import AppStateStore from "../../../stores/AppStateStore"
import * as jobHelper from "../../../helpers/jobHelper"

interface IState {
  showAllChildHierarchyData: boolean
  shiftTemplates: IScheduleShift[]
  selectedShiftTemplates: IScheduleShift[]
  searchText: string
  loading: boolean
  openAddShiftTemplateDialog: boolean
  editShiftTemplate: IScheduleShift
}

export default class ShiftTemplates extends React.Component<any, IState> {
  constructor(props) {
    super(props)
    this.state = {
      showAllChildHierarchyData: true,
      shiftTemplates: [],
      selectedShiftTemplates: [],
      searchText: "",
      loading: false,
      openAddShiftTemplateDialog: false,
      editShiftTemplate: null,
    }
    autobind(this)
  }

  componentDidMount() {
    AccountStore.on("account_change", this.getShiftTemplates)
    HierarchySettingsStore.on("global_change", this.getShiftTemplates)
    this.getShiftTemplates()
  }

  componentWillUnmount() {
    AccountStore.removeListener("account_change", this.getShiftTemplates)
    HierarchySettingsStore.removeListener("global_change", this.getShiftTemplates)
  }

  getShiftTemplates() {
    this.setState({ loading: true }, () => {
      const hierarchyIdsForShowAllChildHierarchyData = hierarchyHelper.getHierarchyIdsForShowAllChildHierarchyData(
        this.state.showAllChildHierarchyData,
        HierarchySettingsStore.getGlobalLevelItemFilterId()
      )
      const shiftTemplates = AccountStore.getCurrentAccount().ScheduleData.ShiftTemplates
        .filter((item) =>
          !item.Deleted &&
          (
            AccountStore.getJobsEnabled() ?
              jobHelper.getSupervisorAccessJobPermission(item.JobId) :
              true
          ) &&
          (hierarchyIdsForShowAllChildHierarchyData.find((id) => id === item.HierarchyId) === undefined ? false : true) &&
          (this.state.searchText ?
            item.Name.toLowerCase().includes(this.state.searchText.toLowerCase()) || item.Description.toLowerCase().includes(this.state.searchText.toLowerCase()) :
            true)
        )
        .sort((a, b) => {
          if (a.Name < b.Name) return -1
          if (a.Name > b.Name) return 1
          return 0
        })

      this.setState({
        loading: false,
        shiftTemplates,
        selectedShiftTemplates: [],
      })
    })
  }

  handleAdd(shiftTemplate) {
    this.checkHierarchy(shiftTemplate, () =>
      this.setState({ openAddShiftTemplateDialog: false, editShiftTemplate: null }, () => {
        AppStateStore.setProgressSnackbarContent("loading")
        AccountActions.addShiftTemplate(AccountStore.getCurrentAccount().Id, shiftTemplate, () =>
          AppStateStore.setProgressSnackbarContent(strings.Shift_template_added_successfully)
        )
      })
    )
  }

  handleUpdate(shiftTemplate) {
    this.checkHierarchy(shiftTemplate, () =>
      this.setState({ openAddShiftTemplateDialog: false, editShiftTemplate: null }, () => {
        AppStateStore.setProgressSnackbarContent("loading")
        AccountActions.updateShiftTemplate(AccountStore.getCurrentAccount().Id, shiftTemplate, () =>
          AppStateStore.setProgressSnackbarContent(strings.Shift_template_updated_successfully)
        )
      })
    )
  }

  checkHierarchy(shiftTemplate: IScheduleShift, cb: () => void) {
    hierarchyHelper.checkHierarchyIsUnderFilterAccessHierarchy(HierarchySettingsStore.getGlobalLevelItemFilterId(), shiftTemplate.HierarchyId) ?
      cb() :
      AppStateStore.setAlertDialogContent({
        content: strings.formatString(strings.You_have_changed_the_hierarchy_of_this_shift_template_so_that_it_is_no_longer_visible_To_see_the_shift_template_change_your_hierarchy_filter_to_X, hierarchyHelper.getFullyQualifiedLevelNameById(shiftTemplate.HierarchyId)) as string,
        handleCloseCallBack: cb
      })
  }

  handleDelete(shiftTemplates: IScheduleShift[]) {
    AppStateStore.setProgressSnackbarContent("loading")
    AccountActions.deleteShiftTemplates(AccountStore.getCurrentAccount().Id, shiftTemplates.map(item => item.Id), () =>
      AppStateStore.setProgressSnackbarContent(strings.Shift_template_deleted_successfully)
    )
  }

  render() {
    return (
      <div className="page-container">
        <div className="page-container-parent">
          {permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.AddAccountSchedule) &&
            <FloatingActionButton data-intercom-target={"menu-Schedules-ShiftTemplates-Btn-Add"} className="fixed-add" style={{ top: 83, right: 40, zIndex: 998 }} secondary={true} onTouchTap={() => this.setState({ openAddShiftTemplateDialog: true })}>
              <ContentAdd />
            </FloatingActionButton>
          }
          <Paper zDepth={1} className="page-paper">
            <div style={{ width: "100%", marginTop: 20, display: "flex", justifyContent: "flex-end" }}>
              <Toggle
                data-intercom-target={"menu-Schedules-ShiftTemplates-Toggle-ShowAllChildHierarchyData"}
                label={strings.Show_All_Child_Hierarchy_Data}
                style={{ width: 275, paddingRight: 35 }}
                labelStyle={{ fontSize: 15, fontWeight: 500 }}
                toggled={this.state.showAllChildHierarchyData}
                onToggle={(e, value) => this.setState({ showAllChildHierarchyData: value }, () => this.getShiftTemplates())}
              />
            </div>
            <TableActionBar
              rowSelectionCount={this.state.selectedShiftTemplates.length}
              singleSelectedMessage={strings.Shift_Template_Selected}
              multipleSelectedMessage={strings.x_Shift_Templates_Selected}
              title={strings.Shift_Templates}
              onSearch={(searchText) => this.setState({ searchText }, () => this.getShiftTemplates())}
              searchText={this.state.searchText}
              onDeleteClick={() =>
                AppStateStore.setConfirmDialogContent({
                  content: strings.Are_you_sure_you_want_to_delete_the_selected_shift_template,
                  confirm: () => this.handleDelete(this.state.selectedShiftTemplates)
                })
              }
              readonly={false}
            />
            <div style={{ padding: 20 }}>
              {this.state.loading ?
                <div className="spinner"><CircularProgress /></div> :
                <div>
                  {!this.state.shiftTemplates.length ?
                    <Table>
                      <TableBody displayRowCheckbox={false}>
                        <TableRow>
                          <TableRowColumn>
                            <h2 style={{ textAlign: "center", marginTop: 25 }}>
                              {strings.No_shift_template_found}
                            </h2>
                          </TableRowColumn>
                        </TableRow>
                      </TableBody>
                    </Table> :
                    <ShiftTemplatesTable
                      shiftTemplates={this.state.shiftTemplates}
                      selectedShiftTemplates={this.state.selectedShiftTemplates}
                      handleUpdate={(editShiftTemplate) => permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule) && this.setState({ openAddShiftTemplateDialog: true, editShiftTemplate })}
                      handleSelect={(selectedShiftTemplates) => this.setState({ selectedShiftTemplates })}
                    />
                  }
                </div>
              }
            </div>
          </Paper>
        </div>
        {this.state.openAddShiftTemplateDialog &&
          <AddShiftTemplateDialog
            isAccountTemplate
            editShiftTemplate={this.state.editShiftTemplate}
            hierarchyId={HierarchySettingsStore.getGlobalLevelItemFilterId()}
            handleClose={() => this.setState({ openAddShiftTemplateDialog: false, editShiftTemplate: null })}
            handleAdd={this.handleAdd}
            handleUpdate={this.handleUpdate}
          />
        }
      </div>
    )
  }
}